var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifyingGlassFindSearchSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M474.9 489.3m-140.3 0a140.3 140.3 0 1 0 280.6 0 140.3 140.3 0 1 0-280.6 0Z",
    fill: "#FFB89A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M582.8 465.5c-13.3 0-24.6 8.7-28.5 20.7h-0.1c-2 6.4-4.6 12.7-7.7 18.7l0.2 0.1c-2.3 4.2-3.6 9.1-3.6 14.3 0 16.6 13.4 30 30 30 13 0 24-8.2 28.2-19.8 3.6-7.3 6.7-14.8 9.3-22.6 1.4-3.5 2.2-7.3 2.2-11.4 0-16.5-13.4-30-30-30z",
    fill: "#33CC99"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M512 552.5c-6.8 0-13 2.3-18.1 6.1-17.9 9.6-38 14.6-58.8 14.6-33.4 0-64.8-13-88.4-36.6-23.6-23.6-36.6-55-36.6-88.4s13-64.8 36.6-88.4c23.6-23.6 55-36.6 88.4-36.6s64.8 13 88.4 36.6c15.6 15.6 26.6 34.7 32.2 55.4v0.2h0.1c2.9 13.5 14.9 23.7 29.3 23.7 16.6 0 30-13.4 30-30 0-3.5-0.6-6.8-1.7-9.9-21.5-78.4-93.2-136-178.4-136-102.2 0-185 82.8-185 185s82.8 185 185 185c33.6 0 65-8.9 92.1-24.6l-0.1-0.2c8.9-5.2 14.9-14.9 14.9-25.9 0.1-16.6-13.3-30-29.9-30z",
    fill: "#33CC99"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M435.1 122.6c42.2 0 83.1 8.3 121.6 24.5 37.2 15.7 70.6 38.3 99.4 67s51.3 62.1 67 99.4c16.3 38.5 24.5 79.4 24.5 121.6 0 42.2-8.3 83.1-24.5 121.6-15.7 37.2-38.3 70.6-67 99.4-28.7 28.7-62.1 51.3-99.4 67-38.5 16.3-79.4 24.5-121.6 24.5s-83.1-8.3-121.6-24.5c-37.2-15.7-70.6-38.3-99.3-67-28.7-28.7-51.3-62.1-67-99.3-16.3-38.5-24.5-79.4-24.5-121.6s8.3-83.1 24.5-121.6c15.7-37.2 38.3-70.6 67-99.4 28.7-28.7 62.1-51.3 99.4-67 38.4-16.3 79.3-24.6 121.5-24.6m0-60c-205.7 0-372.5 166.8-372.5 372.5s166.8 372.5 372.5 372.5 372.5-166.8 372.5-372.5S640.8 62.6 435.1 62.6z",
    fill: "#45484C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M906.7 949.4L671.8 714.5c-11.7-11.7-11.7-30.8 0-42.4 11.7-11.7 30.8-11.7 42.4 0L949.1 907c11.7 11.7 11.7 30.8 0 42.4-11.6 11.6-30.7 11.6-42.4 0z",
    fill: "#45484C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlassFindSearchSvgrepoCom);
export default __webpack_public_path__ + "static/media/magnifying-glass-find-search-svgrepo-com.23bb3cfc63c03f92f03b69d7c026d432.svg";
export { ForwardRef as ReactComponent };